export const withLockGuard =
	<TArgs extends unknown[]>(
		onLockedAction: (() => void) | null,
		action: (...args: TArgs) => void,
	) =>
	(...args: TArgs) => {
		if (onLockedAction) {
			onLockedAction();
			return;
		}
		action(...args);
	};
